// ThirdParty
import { configureStore } from '@reduxjs/toolkit';
import reducers from './reducers';

// project import
export * from './hooks';

// ==============================|| REDUX TOOLKIT - MAIN STORE ||============================== //

const store = configureStore({
  reducer: reducers
});
export function setupStore(preloadedState) {
  return configureStore({
    reducer: reducers,
    preloadedState
  });
}
const { dispatch } = store;

export { store, dispatch };
